import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../util/axiosConfig";
import "../../assets/css/container/board/UpdateNotice.css";
import "../../assets/css/component/board/BoardActions.css";
import { useAuth } from "../../global/AuthContext";
import TiptapEditor from "../../component/TiptapEditor";


export default function UpdateNotice() {
	const { id } = useParams();
	const { user } = useAuth();
	const navigate = useNavigate();

	const [title, setTitle] = useState("");
	const [content, setContent] = useState("");

	useEffect(() => {
		// 기존 공지 불러오기
		axios.get(`/api/notices/${id}`)
			.then(res => {
				setTitle(res.data.title);
				setContent(res.data.content);
			})
			.catch(err => {
				console.error(err);
				alert("공지사항을 불러오지 못했습니다.");
				navigate("/notices");
			});
	}, [id, navigate]);

	if (user?.role !== "admin") {
		return <p>권한이 없습니다.</p>;
	}

	const handleUpdate = async () => {
		if (!title.trim() || !content.trim()) {
			alert("제목과 내용을 입력해주세요.");
			return;
		}

		try {
			await axios.put(`/api/notices/${id}`, { title, content });
			alert("수정되었습니다.");
			navigate(`/notices/${id}`);
		} catch (err) {
			console.error(err);
			alert("수정 중 오류 발생");
		}
	};

	return (
		<div className="UpdateNotice">
			<h2>공지 수정</h2>
			<input
				type="text"
				placeholder="제목 입력"
				value={title}
				onChange={(e) => setTitle(e.target.value)}
			/>
			<TiptapEditor content={content} onChange={setContent} />

			<div className="BoardEditorActions">
				<button onClick={handleUpdate}>수정 완료</button>
				<button onClick={() => navigate(`/notices/${id}`)}>취소</button>
			</div>
		</div>
	);
}
